var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptoCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-5 h-5 text-icon-color-teal dark:text-dark-icon-color-teal",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.515 2.574a1 1 0 0 1-.46 1.337 9 9 0 0 0-4.967 9.341 1 1 0 0 1-1.98.279 11 11 0 0 1 6.07-11.418 1 1 0 0 1 1.337.46m6.97 0a1 1 0 0 1 1.337-.46 11 11 0 0 1 6.07 11.417 1 1 0 0 1-1.98-.279 9 9 0 0 0-4.967-9.341 1 1 0 0 1-.46-1.337M12 7.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M5.5 12a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0m-.187 7.502a1 1 0 0 1 1.397-.22 9 9 0 0 0 10.58 0 1 1 0 0 1 1.176 1.617 11 11 0 0 1-12.932 0 1 1 0 0 1-.221-1.397",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoCurrency);
export default __webpack_public_path__ + "static/media/CryptoCurrency.ead38975988b2db6400d38518d0c33bb.svg";
export { ForwardRef as ReactComponent };